import { useState } from "react"
import { DateRangePicker as GoDesignDateRangePicker, Day } from "@gogoro/go-design"
import { addDays, endOfDay, startOfDay } from "date-fns"

import { DateRangePickerProps } from "./DateRangePickerProps"

function DateRangePicker<T>({
  value = [],
  name,
  onChange = () => {},
  clearable = true,
  formatOutput = (date: any) => {
    return date
  },
  formatInput = (date: any) => {
    return date
  },
  max = 0,
  testId,

  ...restProps
}: DateRangePickerProps<T> & { myRef?: any }) {
  const [tempDate, setTempDate] = useState<Array<Day | null>>([formatInput(value[0]), formatInput(value[1])])

  const handleOnChange = (value: Day[]) => {
    if (value) {
      const start = value[0] && startOfDay(value[0])
      const end = value[1] && endOfDay(value[1])
      setTempDate([start, end])
    }
  }

  const handleOnApply = (value: Day[]) => {
    if (value[0] && value[1]) {
      const start = value[0] && startOfDay(value[0])
      const end = value[1] && endOfDay(value[1])
      onChange([formatOutput(start), formatOutput(end)])
    }
  }

  const handleOnClose = () => {
    if (!tempDate[0] || !tempDate[1]) {
      setTempDate([formatInput(value[0]) || null, formatInput(value[1]) || null])
    }
  }

  const handleOnClear = () => {
    setTempDate([null, null])
    onChange([null, null])
  }

  let minDate = null,
    maxDate = null
  if (max) {
    maxDate = tempDate[0] && addDays(tempDate[0], max)
    minDate = tempDate[0] && addDays(tempDate[0], -max)
  }

  // fix me after the component can accept ref
  const props = {
    ...restProps,
    //ref: myRef,
  }

  return (
    <GoDesignDateRangePicker
      onChange={handleOnChange}
      onApply={handleOnApply}
      onClose={handleOnClose}
      onClear={handleOnClear}
      {...props}
      clearable={clearable}
      autoApply
      startDate={tempDate[0]}
      endDate={tempDate[1]}
      minDate={minDate}
      maxDate={maxDate}
      testId={testId}
    />
  )
}

export default DateRangePicker
